import { FC, ReactNode } from 'react';

import { HasCommonContent } from '@silvertours/common-landingpages-view';
import {
  PageLegacy,
  PageNavigationLegacy,
  SupportInfoLegacy,
  Suppliers,
} from '@silvertours/front-features';

import { ContentModulesRenderer } from './content';
import { ContentModules } from './ContentModules';

type BodyProps = HasCommonContent & {
  stage: ReactNode;
  title?: string;
  content: ContentModulesRenderer;
  includeSearch?: boolean;
};

const Body: FC<BodyProps> = ({
  title,
  breadcrumbs,
  content,
  suppliers,
  stage,
  includeSearch = true,
}) => (
  <PageLegacy.PageContentBase>
    {stage}
    <Suppliers.Suppliers
      title={title}
      suppliers={suppliers.content}
      includeSearch={includeSearch}
    />
    <PageNavigationLegacy.Breadcrumbs breadcrumbs={breadcrumbs.links} />
    <ContentModules content={content} />
    <SupportInfoLegacy.ContactUs />
  </PageLegacy.PageContentBase>
);
export { Body };
